import { useState } from "react";
import ResponseAdditionCode from "./ResponseAdditionCode"
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCopy } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { selectSettings } from "../features/settings/settingsSlice";
const AdditionListView = ({additions, type}) =>{
    const [isCopy, setIsCopy] = useState("")
    const {formatCode} = useSelector(selectSettings)

    const copyBtn = (addition) =>{
      setIsCopy(addition.qid )
      navigator.clipboard.writeText(addition.body)
      setTimeout(()=>{
        setIsCopy("")
      }, 3000)
    }
    if(!additions?.length) return null


    const area = (addition)=>{
        if(type==="Code" && addition.qhighlight && formatCode)
        return  <div className="code-container">
   <div className="code-header">
    <p>{addition.qtext}</p>
   {isCopy !== addition.qid? <button  onClick={()=>copyBtn(addition)}><FontAwesomeIcon icon={faCopy} /> Copy Code    </button>
     :<button><FontAwesomeIcon icon={faCheck} /> !Copied    </button> }
     </div>
      <SyntaxHighlighter wrapLongLines={true} wrapLines={true} language={addition.qlanguage} style={darcula}>
      {addition.body}
      </SyntaxHighlighter> </div>

    else{
        return   <textarea readOnly
        className={`form__input ${type==="Code"? " form__input--ltr" :""}  form__input--body  `}
        id={`body-${addition.qid}`}
        name={`body-${addition.qid}`}
        value={addition.body}
        
    />
    }
    }
 
    return (<>
       { additions.map(addition=>{
            return <>
                   <span className='grid-results-header'>
                   <div className='sticky'> {addition.qtext}</div>
                    </span>
                   <span className='grid-results-data'>
                   {area(addition)}
                    </span>
                   </>
        })
       }
    </>)
}
export default AdditionListView